import { render, staticRenderFns } from "./HeaderList.vue?vue&type=template&id=43b6c56b"
import script from "./HeaderList.vue?vue&type=script&lang=js"
export * from "./HeaderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports